import { useState, useEffect } from "react";

import HotelCalendar from "./Calendar";
import proxy from "api/proxy";
import colors from "theme/colors";
import helper from "./calendar/helper";
import { getStorage } from "store/local";

const model = "hotel.room";

function Rack() {
  const [rooms, setRooms] = useState([]);
  const session = getStorage("ctxSession");

  function orderedRooms(data) {
    const groupRooms = new Map();
    for (const room of data) {
      const accoId = room["accommodation."].id;
      const { name, id: roomId, type_: categoryId } = room;
      if (!groupRooms.get(accoId)) {
        const dataAcco = {
          rooms: new Map(),
          accoId: accoId,
          accoName: room["accommodation."].name,
        };

        groupRooms.set(accoId, dataAcco);
      }
      const group = groupRooms.get(accoId);
      const categoryName = room["type_."].name;
      group.rooms.set(roomId, {
        id: roomId,
        name: name,
        categoryId: categoryId,
        categoryName: categoryName,
        categoryColor: colors.colorsBg[categoryId],
      });
    }
    return groupRooms;
  }

  async function getRooms() {
    const fields_names = [
      "name",
      "type_",
      "type_.name",
      "accommodation",
      "accommodation.name",
    ];
    const order = [["code", "ASC"]];
    const dom = [
      ["active", "=", true],
      ["operation_center.shops", "=", session.shop],
    ];

    // ONLY FOR TESTING PURPOSES
    const rolOwner = await helper.getOwnerUser();
    if (rolOwner) {
      store.set("owner", true);
      dom.push(["authorized_users", "in", [session.user]]);
    }
    const { data } = await proxy.search(model, dom, fields_names, 500, order);
    const _rooms = orderedRooms(data);
    setRooms(_rooms);
  }

  useEffect(() => {
    getRooms();
  }, []);

  return <HotelCalendar rooms={rooms} />;
}

export default Rack;
